import styles from "./Navbar.module.css"
const Navbar = () => {
    return (
        <nav className={styles.navbar}>
            <h2 className={styles.header}>Personal Book Manager</h2>
        </nav>
    )
}

export default Navbar